export const goToWhatApp = (phone: string, message: string): void => {
  const url = `https://api.whatsapp.com/send/?phone=${phone.replace(
    "+",
    "",
  )}&text=${message}`;
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
